import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { WorkOrdersStore, WorkOrdersState } from './workorders.store';
import { combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkOrdersQuery extends QueryEntity<WorkOrdersState> {
  selectFilters$ = this.select('filters');
  selectSearchTerm$ = this.select((state) => state.filters.searchTerm);
  selectState$ = this.select((state) => state.filters.state);

  getCounterByState(state: string) {
    const maxLenght = 99;
    return combineLatest([this.selectAll({ filterBy: (e) => e.workOrderState == state }), this.selectSearchTerm$]).pipe(
      map(([workorders, searchTerm]) => {
        if (searchTerm) {
          workorders = workorders.filter(
            (wo) =>
              wo.externalId?.includes(this.searchTerm!) ||
              wo.clientName?.toLowerCase().includes(this.searchTerm!.toLocaleLowerCase()) ||
              wo.clientAddress?.toLowerCase().includes(this.searchTerm!.toLocaleLowerCase())
          );
        }

        return workorders.length <= maxLenght ? workorders.length : maxLenght;
      })
    );
  }

  get filters() {
    return this.getValue().filters;
  }

  get searchTerm() {
    return this.getValue().filters.searchTerm;
  }

  get state() {
    return this.getValue().filters.state;
  }

  constructor(protected override store: WorkOrdersStore) {
    super(store);
  }
}
